<div class="account-pages mt-5 pt-5 mb-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card bg-pattern">

          <div class="card-body p-4">

            <div class="text-center w-75 m-auto">
              <a href="index.html">
                <span><img src="assets/images/acs_logo.png" alt="" height="100"></span>
              </a>
              <h5 class="text-uppercase text-center font-bold mt-4">Sign In</h5>

            </div>

            <form action="mt-3" (ngSubmit)="login()" #loginForm="ngForm" autocomplete="off">

              <div class="form-group mb-3">
                <label for="emailaddress">Email address</label>
                <input [(ngModel)]="email" [ngModelOptions]="{standalone: true}" class="form-control" type="email" id="emailaddress" required="" placeholder="Enter your email">
              </div>

              <div class="form-group mb-3">
                <a routerLink="./forgot-password" routerLinkActive="active" class="text-muted float-right"><small>Forgot your password?</small></a>
                <label for="password">Password</label>
                <input [(ngModel)]="password" [ngModelOptions]="{standalone: true}" class="form-control" type="password" required="" id="password" placeholder="Enter your password">
              </div>

              <div class="form-group mb-3" *ngIf="loginFailed">
                <ngb-alert type="danger" [dismissible]="false">
                  <strong>Error!</strong> {{errorMessage}}
                </ngb-alert>
              </div>

              <div class="form-group mb-0 text-center">
                <button [disabled]="!loginForm.form.valid" class="btn btn-gradient btn-block" type="submit"> Log In </button>
              </div>

            </form>

          </div> <!-- end card-body -->
        </div>
        <!-- end card -->



      </div> <!-- end col -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</div>
